/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationLogoModel } from '../../models/organization-logo-model';

export interface AdminFhirIdLogoPost$Params {
  fhirId: string;
      body?: OrganizationLogoModel
}

export function adminFhirIdLogoPost(http: HttpClient, rootUrl: string, params: AdminFhirIdLogoPost$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<string | null>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdLogoPost.PATH, 'post');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<string | null>;
    })
  );
}

adminFhirIdLogoPost.PATH = '/Admin/{fhirId}/Logo';
